import { store } from '@sonifi/wb-core/store/store';
import { getHomeImages } from '../services/home.service';

export async function loaderHome() {
  const {
    home: { images },
  } = store.getState();

  if (!images.length) {
    await store.dispatch(getHomeImages());
  }
  return images;
}
